import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import Pictogram from '../global/pictogram';
import Duration from '../global/duration';
import TranslatedCopy from '../../intl/translated-copy';
import { TIME_FORMATS, WEEKDAY_WITH_MONTH_DAY } from '../../constants/date-time-formats';
import { getFareAndCabinName, getFareFamilyName, getHostFromCMS } from '../../utilities/helpers';
function IropsItinearyCards({
  allDestinationInfo,
  country,
  flag,
  flightTime,
  isOneWay,
  isRoundTrip,
  iteration,
  itineraryPartType,
  language,
  legModel,
  legIndex,
  tripTag }) {
  const imgHero = allDestinationInfo?.[legModel?.getDestinationCode()]?.secondaryImage || '';
  const urlValid = imgHero.includes('http');
  const contImgHero = urlValid ? imgHero : getHostFromCMS() + imgHero;
  const imageHero = contImgHero;

  const getCopyFlightCount = (isOneWay, isRoundTrip, iteration, itineraryPartType) => {
    const isMultiCity = !isOneWay && !isRoundTrip;

    if (isMultiCity) {
      return <TranslatedCopy copyID='APP_FLIGHT_NUMBER' flightNum={ iteration } />;
    } else if (isOneWay || itineraryPartType === 'OUTBOUND') {
      return <TranslatedCopy copyID='MENU_RESERVA_DATES_OW' />;
    } else {
      return <TranslatedCopy copyID='APP_RETURNING' />;
    }
  };
  const copyTextFlight = getCopyFlightCount(isOneWay, isRoundTrip, iteration, itineraryPartType);
  const numberOfStops = legModel?.segmentsCollection?.length - 1 > 0 ? legModel?.segmentsCollection?.length - 1 : legModel?.segmentsCollection?.[0]?.stops?.length;
  const segmentsByLeg = legModel?.segmentsCollection;
  const arrivalAirport = segmentsByLeg?.[0]?.arrivalAirport;
  const arrivalTime = legModel.getArrivalDate(TIME_FORMATS[country]);
  const departureAirport = segmentsByLeg?.[0]?.departureAirport;
  const departureTime = legModel.getDepartureDate(TIME_FORMATS[country], language);
  const day = legModel.getDepartureDate(WEEKDAY_WITH_MONTH_DAY[country], language);

  const arrivalTerminal = segmentsByLeg?.[0]?.arrivalTerminal;
  const departureTerminal = segmentsByLeg?.[0]?.departureTerminal;
  const arrayFareAndCabin = getFareAndCabinName(segmentsByLeg);
  const arrayFare = getFareFamilyName(segmentsByLeg);

  const iconFareFamily = cx({
    'Icon': true,
    'Icon-color-blue': true,
    // Estas familias son fuente
    'Icon--fareAmPlus': arrayFareAndCabin?.[0] === 'AMPLUS_FARE_TOURIST_CABIN' || false,
    'Icon--fareClassic': arrayFareAndCabin?.[0] === 'CLASSIC_FARE_TOURIST_CABIN' || false,
    'Icon--fareBasic': arrayFareAndCabin?.[0] === 'BASIC_FARE_TOURIST_CABIN' || false,
    'Icon--fareFlexible': arrayFareAndCabin?.[0] === 'FLEXIBLE_FARE_TOURIST_CABIN' || false,
    // Estas familias son imagenes
    'fareComfortSeat': arrayFareAndCabin[0] === 'COMFORT_FARE_PREMIER_CABIN' || false,
    'farePremier': arrayFareAndCabin?.[0] === 'PREMIER_FARE_PREMIER_CABIN' || arrayFareAndCabin?.[0] === 'PREMIER_FLEXIBLE_FARE_PREMIER_CABIN' || false,
    'Icon--farePremierLight': arrayFareAndCabin?.[0] === 'PREMIER_LIGHT_FARE_PREMIER_CABIN' || false,
    'farePremierOne': arrayFareAndCabin?.[0] === 'PREMIER_ONE_FARE_PREMIER_CABIN' || false,
  });

  const flagClasses = cx({
    'itinerary-cards-container disable-trip': !flag,
    'itinerary-cards-container': flag,
  });

  const itineraryCardsLabel = cx({
    'itinerary-cards without-label': tripTag === 1,
    'itinerary-cards originalInfo': tripTag === 2,
    'itinerary-cards with-label': tripTag !== 1 && tripTag !== 2,
  });

  const getTerminalAbbreviation = (terminal) => {
    if (!terminal) return null;
    const firstLetter = terminal?.charAt(0);
    const lastLetter = terminal?.charAt(terminal?.length - 1);

    return firstLetter.concat(lastLetter);
  };

  const renderTimeAndStops = (segmentsByLeg) => {
    const connectionsList = [];
    const terminalNumber = [];

    (segmentsByLeg || []).forEach((segment) => {
      if (segment?.layoverToNextSegmentsInMinutes) {
        (connectionsList || []).push({
          airportCode: segment?.arrivalAirport,
          durationInMinutes: segment?.layoverToNextSegmentsInMinutes,
        });
      }

      const { arrivalAirport, arrivalTerminal, departureAirport, departureTerminal } = segment;

      if (arrivalAirport === 'MEX' && (arrivalTerminal === 'TERMINAL 1' || arrivalTerminal === 'TERMINAL 2') && !terminalNumber?.includes(arrivalTerminal)) {
        terminalNumber.push(arrivalTerminal);
      }
      if (departureAirport === 'MEX' && (departureTerminal === 'TERMINAL 1' || departureTerminal === 'TERMINAL 2') && !terminalNumber?.includes(departureTerminal)) {
        terminalNumber.push(departureTerminal);
      }
    });

    const shortTerminalNumber = [];
    terminalNumber.forEach((terminal) => {
      if (terminal) {
        shortTerminalNumber.push(terminal?.charAt(0) + terminal?.charAt(terminal?.length - 1));
      }
    });

    return (
      <div className='ManageOptionsRoutesItem-timeline--label'>
        <ul className='ManageOptionsRoutesItem-timeline-connectionsList'>
          { connectionsList?.map((item, i) =>
            (<li className='ManageOptionsRoutesItem-timeline-connectionsList--segment'
              key={ i }>
              <span className='ManageOptionsRoutesItem-timeline-connectionAirport'>
                { item?.airportCode }
              </span>
              { item?.airportCode === 'MEX' && terminalNumber?.length === 1 ?
                <div className='ManageOptionsRoutesItem-timeline--terminalNumber'>
                  <p>{ shortTerminalNumber }</p>
                </div>
                : null }
              <Duration 
                className='ManageOptionsRoutesItem-timeline-layoverTime'
                durationInMinutes={ item?.durationInMinutes }
              />
              { item?.airportCode === 'MEX' && terminalNumber?.length === 2 ?
                <div className='ManageOptionsRoutesItem-timeline-changeTerminal'>
                  <TranslatedCopy copyID='MYB_TERMINAL_CAMBIOTERMINAL'
                    className='ManageOptionsRoutesItem-timeline-changeTerminal--text'
                  />
                  <div className='ManageOptionsRoutesItem-timeline--terminalNumber'>
                    <p>
                      { shortTerminalNumber.join(' - ') }
                    </p>
                  </div>
                </div>
                : null }
            </li>)
          ) }
        </ul>
      </div>
    );
  };

  return (
    <>
      <div className={ flagClasses }>
        { legIndex > 0 && <div className='divider-line' /> }
        <div className={ itineraryCardsLabel } >
          <div className='itinerary-source-image'>
            <div className='itinerary-image-container'>
              { imgHero !== '' ?
                <img
                  alt='imagen de destino'
                  className='itinerary-trip-image'
                  src={ imageHero }
                /> :
                null }
              { flightTime === 'flight-cancel' && 
              <Pictogram 
                className='warningAlert-image'
                id='warningAlert'
              /> }
            </div>
            <div className='itinerary-date-info'>
              <div className='itinerary-information'>
                <div className='itinerary-departing'>
                  <TranslatedCopy
                    copyID={ copyTextFlight }
                    tagName='p'
                  />
                </div>
                <TranslatedCopy
                  className='itinerary-date'
                  copyID={ day }
                  tagName='p'
                />
              </div>
            </div>
          </div>
          <div className='itinerary-time-terminal'>
            <div className='itinerary-source-info'>
              <TranslatedCopy
                className='itinerary-departure-time'
                copyID={ departureTime }
                tagName='p'
              />
              <div className='itinerary-source-terminal'>
                <TranslatedCopy
                  className='itinerary-source'
                  copyID={ departureAirport }
                />
                { departureTerminal !== 'N/D' ?
                  <span className='itinerary-terminal'>
                    { getTerminalAbbreviation(departureTerminal) }
                  </span> :
                  null }
              </div>
            </div>
            <div className='ItineraryCard-timeline--content'>
              <div className='ItineraryCard-timeline--bar'>
                { Boolean(numberOfStops) && <div className='ItineraryCard-timeline--count'>{ Boolean(numberOfStops) }</div> }
              </div>
              { Boolean(numberOfStops) && renderTimeAndStops(segmentsByLeg) }
            </div>
            <div className='itinerary-destination-info'>
              <TranslatedCopy
                className='itinerary-arrival-time'
                copyID={ arrivalTime }
                tagName='p'
              />
              <div className='itinerary-destination-terminal'>
                <TranslatedCopy className='itinerary-destination' copyID={ arrivalAirport } />
                { arrivalTerminal !== 'N/D' ?
                  <span className='itinerary-terminal'>
                    { getTerminalAbbreviation(arrivalTerminal) }
                  </span> :
                  null }
              </div>
            </div>
          </div>
          <div className='itinerary-details-section'>
            <div>
              <div className='itinerary-flight-no-container'>
                <span className='itinerary-flight-no'>{ segmentsByLeg?.[0]?.marketingCarrier } { segmentsByLeg?.[0]?.marketingFlightCode }</span>
              </div>
              <div className='itinerary-flight-type-container'>
                <TranslatedCopy className='itinerary-flight-type' copyID='APP_NUM_STOPS'
                  numStops={ numberOfStops } />
                <Duration durationInMinutes={ legModel?.totalFlightTimeInMinutes } />
              </div>
            </div>
            <div className='itinerary-flight-fare-container'>
              <div className='ItineraryCard-details--icon'>
                <div className={ iconFareFamily } />
              </div>
              { arrayFareAndCabin?.[0] !== null && arrayFareAndCabin?.[0] !== '' ?
                <TranslatedCopy className='itinerary-flight-fare' copyID={ arrayFare?.[0] } /> : null
              }
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

IropsItinearyCards.propTypes = {
  allDestinationInfo: PropTypes.object,
  country: PropTypes.string,
  flag: PropTypes.bool,
  flightTime: PropTypes.string,
  isOneWay: PropTypes.bool,
  isRoundTrip: PropTypes.bool,
  iteration: PropTypes.number,
  language: PropTypes.string,
  legModel: PropTypes.object,
  legIndex: PropTypes.number,
  tripTag: PropTypes.number,
  tripType: PropTypes.string,
};

IropsItinearyCards.defaultProps = {
  allDestinationInfo: {},
  country: '',
  flag: false,
  flightTime: '',
  isOneWay: false,
  isRoundTrip: false,
  iteration: null,
  language: '',
  legModel: {},
  legIndex: null,
  tripTag: null,
  tripType: '',
};

export default IropsItinearyCards;